/* ============================================================
   CAM - Section 1 de la landing "Camera de surveillance solaire".
   IIFE : aucune variable globale, scope distinct des autres landings.

   PACKS x1 / x2 / x3 / x4
     data-qty  : quantite reellement envoyee au panier ;
     data-disc : pourcentage de remise AFFICHE pour ce pack.
   data-disc n'applique AUCUNE remise : il doit refleter une remise
   automatique Shopify reellement active pour cette quantite minimale.
   Tant qu'aucune remise n'existe, le gabarit garde data-disc a 0 et le
   prix affiche est exactement ce que le panier facture.

   PRIX ET VARIANTES : tout vient de Shopify. Aucun montant, aucun
   identifiant n'est ecrit en dur ici.

   GALERIE : la page s'ouvre sur le PREMIER media de la fiche produit ;
   elle ne suit la variante qu'apres une action du client.

   Un seul clic = un seul ajout : le verrou `occupe` est pose avant la
   requete et n'est pas relache quand on part au paiement.
   ============================================================ */
(function () {
  'use strict';

  var MARQUE = 'camPret';
  var DELAI_GALERIE = 350;

  function chacun(l, f) { Array.prototype.forEach.call(l, f); }

  function entier(el, attr, def) {
    var v = parseInt(el && el.getAttribute(attr), 10);
    return isNaN(v) ? def : v;
  }

  function Achat(racine) {
    this.racine = racine;
    this.money = racine.getAttribute('data-cam-money') || '{{amount}}';
    this.paiementDirect = racine.getAttribute('data-cam-checkout') === 'true';

    var json = racine.querySelector('[data-cam-variants]');
    try { this.variantes = JSON.parse(json ? json.textContent : '[]'); }
    catch (e) { this.variantes = []; }

    this.pastilles = racine.querySelectorAll('[data-cam-var]');
    this.offres = racine.querySelectorAll('[data-cam-offer]');
    this.champId = racine.querySelector('[data-cam-id]');
    this.champQte = racine.querySelector('[data-cam-qty]');
    this.form = racine.querySelector('form[action*="/cart/add"]');

    this.bouton = racine.querySelector('[data-cam-cta]');
    this.txtBouton = racine.querySelector('[data-cam-cta-text]');
    this.live = racine.querySelector('[data-cam-live]');
    this.choisi = racine.querySelector('[data-cam-chosen]');

    this.now = racine.querySelector('[data-cam-now]');
    this.was = racine.querySelector('[data-cam-was]');
    this.off = racine.querySelector('[data-cam-off]');
    this.stock = racine.querySelector('[data-cam-stock]');
    this.stockTxt = racine.querySelector('[data-cam-stock-text]');

    this.txt = {
      achat: racine.getAttribute('data-cam-cta-label') || 'ACHETER MAINTENANT',
      chargement: racine.getAttribute('data-cam-loading') || 'REDIRECTION...',
      succes: racine.getAttribute('data-cam-done') || 'REDIRECTION...',
      erreur: racine.getAttribute('data-cam-error') || 'Reessayez',
      rupture: racine.getAttribute('data-cam-sold') || 'INDISPONIBLE',
      enStock: racine.getAttribute('data-cam-instock') || 'En stock',
      horsStock: racine.getAttribute('data-cam-outstock') || 'Rupture de stock'
    };

    this.occupe = false;
    this.indisponible = false;
    this.sequence = 0;
    this.premierRendu = true;

    this.brancherVariantes();
    this.brancherOffres();
    this.brancherGalerie();
    this.brancherPanier();
    this.rendre();
  }

  /* ---------------- Variantes ---------------- */

  Achat.prototype.parId = function (id) {
    for (var i = 0; i < this.variantes.length; i++) {
      if (String(this.variantes[i].id) === String(id)) { return this.variantes[i]; }
    }
    return null;
  };

  Achat.prototype.varianteCourante = function () {
    for (var i = 0; i < this.pastilles.length; i++) {
      if (this.pastilles[i].getAttribute('aria-pressed') === 'true') {
        var v = this.parId(this.pastilles[i].getAttribute('data-cam-vid'));
        if (v) { return v; }
      }
    }
    return this.variantes[0] || null;
  };

  Achat.prototype.brancherVariantes = function () {
    var self = this;
    chacun(this.pastilles, function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) { return; }
        chacun(self.pastilles, function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        self.rendre();
      });
    });
  };

  /* ---------------- Offres ---------------- */

  Achat.prototype.offreActive = function () {
    for (var i = 0; i < this.offres.length; i++) {
      if (this.offres[i].getAttribute('aria-pressed') === 'true') { return this.offres[i]; }
    }
    return this.offres[0] || null;
  };

  Achat.prototype.brancherOffres = function () {
    var self = this;
    chacun(this.offres, function (o) {
      o.addEventListener('click', function () {
        chacun(self.offres, function (x) {
          x.setAttribute('aria-pressed', x === o ? 'true' : 'false');
        });
        self.rendre();
      });
    });
  };

  /* ---------------- Montants ---------------- */

  Achat.prototype.montants = function (offre, v) {
    var qte = Math.max(1, entier(offre, 'data-qty', 1));

    var rab = parseFloat(offre && offre.getAttribute('data-disc'));
    if (isNaN(rab) || rab < 0) { rab = 0; }
    if (rab > 90) { rab = 90; }

    var unite = v ? v.p : 0;
    var uniteCmp = (v && v.c > unite) ? v.c : 0;

    /* Calcul en centimes puis arrondi : c'est la meme base que Shopify,
       le total affiche colle donc au total facture. */
    var total = Math.round(unite * qte * (100 - rab) / 100);
    var compare = uniteCmp ? uniteCmp * qte : 0;
    if (compare <= total) { compare = 0; }

    return {
      qte: qte,
      remise: rab,
      total: total,
      compare: compare,
      economie: compare ? (compare - total) : 0
    };
  };

  Achat.prototype.formater = function (cents) {
    var n = (cents / 100).toFixed(2);
    var ent = n.split('.')[0];
    var dec = n.split('.')[1];
    var m = this.money;
    if (m.indexOf('amount_no_decimals_with_comma_separator') > -1) {
      return m.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, ent.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    }
    if (m.indexOf('amount_no_decimals') > -1) {
      return m.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, ent.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
    }
    if (m.indexOf('amount_with_comma_separator') > -1) {
      return m.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, ent.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec);
    }
    if (m.indexOf('amount_with_apostrophe_separator') > -1) {
      return m.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, ent.replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + dec);
    }
    return m.replace(/\{\{\s*amount\s*\}\}/g, ent.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec);
  };

  /* ---------------- Rendu ---------------- */

  Achat.prototype.rendre = function () {
    var v = this.varianteCourante();
    var offre = this.offreActive();
    if (!v) { return; }

    var a = this.montants(offre, v);

    if (this.champId) { this.champId.value = v.id; }
    if (this.champQte) { this.champQte.value = a.qte; }
    if (this.choisi) { this.choisi.textContent = v.t || ''; }

    if (this.now) { this.now.textContent = this.formater(a.total); }
    if (this.was) {
      this.was.hidden = !a.compare;
      if (a.compare) { this.was.textContent = this.formater(a.compare); }
    }
    if (this.off) {
      var pct = a.compare ? Math.round((a.compare - a.total) * 100 / a.compare) : 0;
      this.off.hidden = pct <= 0;
      if (pct > 0) { this.off.textContent = '(-' + pct + '%)'; }
    }

    if (this.stock) {
      this.stock.setAttribute('data-ok', v.a ? 'true' : 'false');
    }
    if (this.stockTxt) {
      this.stockTxt.textContent = v.a ? this.txt.enStock : this.txt.horsStock;
    }

    this.indisponible = !v.a;
    if (!this.occupe) { this.etat('repos'); }

    /* La page doit s'ouvrir sur le premier media : pas de saut au 1er rendu. */
    if (this.premierRendu) {
      this.premierRendu = false;
    } else if (v.m) {
      this.allerMedia(v.m);
    }
  };

  /* ---------------- Etats du bouton ---------------- */

  Achat.prototype.annoncer = function (m) {
    if (this.live) { this.live.textContent = m || ''; }
  };

  Achat.prototype.etat = function (nom, detail) {
    var b = this.bouton;
    if (!b) { return; }

    if (nom === 'repos') {
      b.removeAttribute('data-etat');
      b.disabled = this.indisponible;
      if (this.txtBouton) { this.txtBouton.textContent = this.indisponible ? this.txt.rupture : this.txt.achat; }
      this.annoncer('');
      return;
    }

    b.setAttribute('data-etat', nom);

    if (nom === 'chargement') {
      b.disabled = true;
      if (this.txtBouton) { this.txtBouton.textContent = this.txt.chargement; }
      this.annoncer(this.txt.chargement);
      return;
    }
    if (nom === 'succes') {
      b.disabled = true;
      if (this.txtBouton) { this.txtBouton.textContent = this.txt.succes; }
      this.annoncer(this.txt.succes);
      return;
    }
    if (nom === 'erreur') {
      b.disabled = this.indisponible;
      if (this.txtBouton) { this.txtBouton.textContent = this.txt.erreur; }
      this.annoncer(detail ? this.txt.erreur + '. ' + detail : this.txt.erreur);
    }
  };

  Achat.prototype.reposDiffere = function (jeton, delai) {
    var self = this;
    window.setTimeout(function () {
      if (self.sequence !== jeton) { return; }
      self.occupe = false;
      self.etat('repos');
    }, delai);
  };

  /* ---------------- Ajout puis paiement ---------------- */

  Achat.prototype.brancherPanier = function () {
    var self = this;
    if (!this.bouton || !this.form) { return; }

    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.ajouter();
    });
    this.bouton.addEventListener('click', function (e) {
      e.preventDefault();
      self.ajouter();
    });
  };

  Achat.prototype.urlPaiement = function () {
    var racine = '';
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        racine = window.Shopify.routes.root;
      } else if (window.routes && window.routes.cart_url) {
        racine = window.routes.cart_url.replace(/\/cart$/, '/');
      }
    } catch (e) { racine = ''; }
    racine = String(racine || '/').replace(/\/+$/, '');
    return racine + '/checkout';
  };

  Achat.prototype.ajouter = function () {
    if (this.occupe || this.indisponible) { return; }

    var v = this.varianteCourante();
    if (!v) { return; }
    var a = this.montants(this.offreActive(), v);

    this.occupe = true;
    this.sequence += 1;
    var jeton = this.sequence;
    this.etat('chargement');

    var self = this;
    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    if (url.indexOf('.js') === -1) { url += '.js'; }

    window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: a.qte }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.status) { throw new Error(json.description || json.message || ''); }

        self.etat('succes');

        if (self.paiementDirect) {
          window.location.assign(self.urlPaiement());
          return;
        }

        self.rafraichirPanier();
        self.reposDiffere(jeton, 1200);
      })
      .catch(function (err) {
        self.occupe = false;
        self.etat('erreur', err && err.message);
        self.reposDiffere(jeton, 2600);
      });
  };

  Achat.prototype.rafraichirPanier = function () {
    var tiroir = document.querySelector('cart-drawer');
    try {
      if (tiroir && typeof tiroir.open === 'function') { tiroir.open(); }
    } catch (e) { /* l'ajout a reussi : on ne casse pas la page pour l'affichage */ }

    try {
      if (typeof window.publish === 'function') { window.publish('cart-update', { source: 'cam-hero' }); }
    } catch (e) { /* rien */ }
  };

  /* ---------------- Galerie ---------------- */

  Achat.prototype.brancherGalerie = function () {
    var self = this;
    this.piste = this.racine.querySelector('[data-cam-track]');
    this.diapos = this.racine.querySelectorAll('[data-cam-slide]');
    this.vignettes = this.racine.querySelectorAll('[data-cam-thumb]');
    this.puces = this.racine.querySelectorAll('[data-cam-dot]');
    if (!this.piste) { return; }

    chacun(this.vignettes, function (t, i) {
      t.addEventListener('click', function () { self.aller(i); });
    });
    chacun(this.puces, function (p, i) {
      p.addEventListener('click', function () { self.aller(i); });
    });

    var prev = this.racine.querySelector('[data-cam-prev]');
    var next = this.racine.querySelector('[data-cam-next]');
    if (prev) { prev.addEventListener('click', function () { self.aller(self.indexCourant() - 1); }); }
    if (next) { next.addEventListener('click', function () { self.aller(self.indexCourant() + 1); }); }

    /* Etranglement par horodatage : requestAnimationFrame ne s'execute pas
       quand la page n'est pas rendue (onglet en arriere-plan, volet masque). */
    var dernier = 0;
    this.piste.addEventListener('scroll', function () {
      var t = Date.now();
      if (t - dernier < 90) { return; }
      dernier = t;
      self.marquer(self.indexCourant());
    }, { passive: true });

    this.marquer(0);
  };

  Achat.prototype.indexCourant = function () {
    if (!this.piste || !this.diapos.length) { return 0; }
    var l = this.diapos[0].getBoundingClientRect().width || 1;
    return Math.max(0, Math.min(this.diapos.length - 1, Math.round(this.piste.scrollLeft / l)));
  };

  Achat.prototype.aller = function (i) {
    if (!this.piste || !this.diapos.length) { return; }
    var n = this.diapos.length;
    i = ((i % n) + n) % n;
    var l = this.diapos[0].getBoundingClientRect().width || 0;
    var cible = Math.round(i * l);
    var p = this.piste;
    var avant = p.scrollLeft;
    try { p.scrollTo({ left: cible, behavior: 'smooth' }); }
    catch (e) { p.scrollLeft = cible; }
    window.setTimeout(function () {
      if (Math.abs(p.scrollLeft - avant) < 2 && Math.abs(cible - avant) >= 2) { p.scrollLeft = cible; }
    }, DELAI_GALERIE);
    this.marquer(i);
  };

  Achat.prototype.allerMedia = function (idMedia) {
    for (var i = 0; i < this.diapos.length; i++) {
      if (String(this.diapos[i].getAttribute('data-media-id')) === String(idMedia)) {
        if (i !== this.indexCourant()) { this.aller(i); }
        return;
      }
    }
  };

  /* Une video que l'on quitte doit se taire : sinon le son continue
     derriere l'image suivante. */
  Achat.prototype.calmerVideos = function (i) {
    chacun(this.diapos, function (d, k) {
      if (k === i) { return; }
      chacun(d.querySelectorAll('video'), function (v) {
        try { if (!v.paused) { v.pause(); } } catch (e) { /* rien */ }
      });
    });
  };

  Achat.prototype.marquer = function (i) {
    chacun(this.vignettes, function (t, k) {
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    chacun(this.puces, function (p, k) {
      p.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    this.calmerVideos(i);
  };

  /* ---------------- Initialisation ---------------- */

  function init(racine) {
    var portee = racine && racine.querySelectorAll ? racine : document;
    chacun(portee.querySelectorAll('.cam-s1'), function (r) {
      if (r.dataset[MARQUE] === '1') { return; }
      r.dataset[MARQUE] = '1';
      new Achat(r);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.cam-s1')) { init(e.target); }
  });
})();